import React from 'react'
import './SectionTitle.css'

interface SectionTitleProps {
  title: string
  subtitle?: string
  action?: React.ReactNode
  level?: 'h2' | 'h3'
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
  action,
  level = 'h2',
}) => {
  const Component = level as any
  return (
    <div className="sectionTitle">
      <div className="sectionTitle__content">
        <Component className="sectionTitle__title">{title}</Component>
        {subtitle && <p className="sectionTitle__subtitle">{subtitle}</p>}
      </div>
      {action && <div className="sectionTitle__action">{action}</div>}
    </div>
  )
}
